import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from "../../../components/Button";
import createLink from "../../../../libs/createLink";

class AskForLocalisation extends React.Component {

    render() {
        return (
            <div className="ask-for-location container card column p-16">
                <div className="title-s4 full mb-16">Vous n'avez pas d'emplacement défini <Link to={createLink("userMeProfile")}>(modifier dans
                    le profil)</Link></div>
                <Button className="my-8"
                        size={"medium"}
                        btnStyle={"primary-reverse"}
                        content={"Donner votre position"}/>
                <div className="row full my-8 align-center justify-center lines-arround">Ou</div>
                <div className="row wrap full my-8 justify-space-between">
                    <select className="mr-8 my-4 flex-1">
                        <option>Pays</option>
                    </select>
                    <select className="mx-8 my-4 flex-1">
                        <option>Région</option>
                    </select>
                    <select className="ml-8 my-4 flex-1">
                        <option>Ville</option>
                    </select>
                </div>
                <div className="row full mt-16 justify-end">
                    <Button className="mx-4"
                            size={"small"}
                            btnStyle={"cancel"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button className="ml-4"
                            size={"small"}
                            btnStyle={"primary"}
                            content={"Valider"}/>
                </div>
            </div>
        )
    }
}

export default AskForLocalisation
